/* unplugin-vue-components disabled */import script from "./MemberDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberDetails.vue?vue&type=script&setup=true&lang=js"

import "./MemberDetails.vue?vue&type=style&index=0&id=79c05fdb&lang=scss"

const __exports__ = script;

export default __exports__